/* jshint undef: true, unused: true, indent: 4, jquery: true */
/* global document, window, _gaq */

var showNextStep = function(currentStep, maxStep) {
    // Show next form

    var hideoptions = {"direction":"left","mode":"hide"};
    var nextStep = parseInt(currentStep, 10) + 1;

    if (nextStep > maxStep) {
        processFinal();
        return true;
    }


    var currentStepClass = '.step-' + currentStep;
    var nextStepClass = '.step-' + nextStep;


    $(currentStepClass).effect('slide', hideoptions, function() {
        _gaq.push(['_trackPageview', '/step' + nextStepClass ]);
        $(nextStepClass).fadeIn();
        $('#main-form').attr('data-step', nextStep);
    });

    return nextStep;
};

var processStep = function(step) {
    return true;
};

var generatePostData = function() {

    var dataToPost = {};
    $('#main-form :input').each(function(i, el) {
        el = $(el);
        if (el.attr('type') == 'radio' || el.attr('type') == 'checkbox') {
            if (!el.is(':checked')) {
                return;
            }
        }
        dataToPost[el.attr('name')] = el.val();
    });

    return dataToPost;

};

var processFinal = function() {
    var postData = generatePostData();

    $('#leadresponse_container').load('/process', postData, function() {
        var leadResponse = $('input#avt_lead_response').val();
        if (leadResponse == 'success') {
            successResponseCallback();
        } else {
            invalidResponseCallback();
        }
    });

};

var successResponseCallback = function() {
    window.location = '/thankyou';
    return true;
};

var invalidResponseCallback = function() {
    window.location = '/ineligible';
    return true;
};

/**
 * SVGs yo
 */
$(document).ready(function () {

    // If Google Analytics code did not run, define an empty array so JS errors don't occur
    if (typeof _gaq === 'undefined') {
        _gaq = [];
    }

    // Add SVG icon markup to check list items.
    $(".checks li").prepend("<span class=\"icon-checkmark\"></span>");

    $('.process-button-click').click(function() {
        $(this).data('display_text', $(this).html());
        $(this).html('Processing<img style="width: 4%" src="//d1fd9shixcplvx.cloudfront.net/sites/af5e01cf/img/processing-ellipses.gif">');
        $(this).attr('disabled', 'disabled');
        $(this).parents('form').submit();
        return false;
    });

    // Validation engine
    $('#main-form').validationEngine({'showOneMessage' : true, 'promptPosition':'topLeft'});

    $('#legal-check').bind("jqv.field.result", function(event, field, errorFound, promptText) {
        if (errorFound === true) {
            $('.legal-checkformError').css('background-color', 'transparent');
            $('#legal-check').validationEngine('showPrompt', promptText, 'error', 'topLeft', true);
        }
    });


    $('#main-form').submit(function(e) {
        e.preventDefault();
        var maxStep = ($('#main-form').attr('data-maxstep')) ? $('#main-form').attr('data-maxstep') : 3;
        var step = $(this).attr('data-step') || 1;

        if ($('#main-form').validationEngine('validate')) {
            if (processStep(step)) {
                showNextStep(step, maxStep);
            }
        } else {
            var thisButton = $('#button-step-'+step);
            $(thisButton).removeAttr('disabled');
            $(thisButton).html($(thisButton).data('display_text'));
            return false;
        }

    });

});

// ON Load
$(window).load(function () {
    /**
     * Animated Home Page logo
     */
    //Remove Home page preload class so magic can happen

    $("body").removeClass("preload");


    $(".cssanimations #masthead").stop().queue(function () {
        $(this).addClass('fadeInDown');
    });

    // Form Page
    $(".cssanimations .banner-text").stop().delay(300).queue(function () {
        $(this).addClass('fadeInUp');
    });
    $(".cssanimations .cta-bar").stop().delay(500).queue(function () {
        $(this).addClass('fadeInUp');
    });
    $(".cssanimations .main-footer").stop().delay(700).queue(function () {
        $(this).addClass('fadeInUp');
    });

    $(".cssanimations .form-container").stop().delay(1200).queue(function () {
        $(this).addClass('fadeInRight');
    });

     // Thank You page
    $(".cssanimations .basic-content").stop().delay(300).queue(function () {
        $(this).addClass('fadeInUp');
    });


});
